var g = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var n = (e, l, c) => l in e ? g(e, l, { enumerable: !0, configurable: !0, writable: !0, value: c }) : e[l] = c, i = (e, l) => {
  for (var c in l || (l = {}))
    v.call(l, c) && n(e, c, l[c]);
  if (a)
    for (var c of a(l))
      h.call(l, c) && n(e, c, l[c]);
  return e;
};
var o = (e, l) => {
  var c = {};
  for (var t in e)
    v.call(e, t) && l.indexOf(t) < 0 && (c[t] = e[t]);
  if (e != null && a)
    for (var t of a(e))
      l.indexOf(t) < 0 && h.call(e, t) && (c[t] = e[t]);
  return c;
};
import * as r from "react";
const w = (t) => {
  var s = t, {
    title: e,
    titleId: l
  } = s, c = o(s, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", i({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 1024 1024", fill: "currentColor", "aria-labelledby": l }, c), e ? /* @__PURE__ */ r.createElement("title", { id: l }, e) : null, /* @__PURE__ */ r.createElement("path", { d: "M810.667 842.581h-603.733c-62.039-3.377-111.066-54.505-111.066-117.085 0-15.949 3.184-31.154 8.952-45.014l-0.286 0.776c0.563-1.663 1.183-3.072 1.909-4.417l-0.074 0.15 302.933-522.325c20.508-36.046 58.661-59.961 102.4-59.961s81.892 23.915 102.097 59.382l0.303 0.579 302.933 522.325c0.768 1.493 1.237 2.731 2.005 4.267 5.402 13.006 8.539 28.112 8.539 43.95 0 64.497-52.020 116.844-116.393 117.372h-0.050zM464.768 186.155c0 0.256-0.256 0.256-0.256 0.512l-301.568 520.533c-2.037 5.429-3.216 11.704-3.216 18.254 0 28.487 22.299 51.766 50.394 53.334l0.139 0.006h600.149c29.25-0.421 52.799-24.231 52.799-53.541 0-6.474-1.149-12.68-3.254-18.425l0.119 0.372-301.653-520.533c0-0.256-0.256-0.256-0.256-0.512-9.301-16.512-26.719-27.481-46.699-27.481s-37.398 10.969-46.56 27.213l-0.139 0.267zM480 640v-0.512c0-17.673 14.327-32 32-32s32 14.327 32 32v0 0.512c0 17.673-14.327 32-32 32s-32-14.327-32-32v0zM480 522.667v-149.333c0-17.673 14.327-32 32-32s32 14.327 32 32v0 149.333c0 17.673-14.327 32-32 32s-32-14.327-32-32v0z" }));
};
export {
  w as default
};
